import { render, staticRenderFns } from "./WfUserDevCollectionModal.Style#Drawer.vue?vue&type=template&id=7139b710&scoped=true&"
import script from "./WfUserDevCollectionModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./WfUserDevCollectionModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./WfUserDevCollectionModal.Style#Drawer.vue?vue&type=style&index=0&id=7139b710&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7139b710",
  null
  
)

export default component.exports